module.exports = __webpack_public_path__ + "img/9788954621588.33fa6c72.jpg";